/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260430
*/

'use strict';
import { allSettled } from './ctssJQuery.js';
import { getMemberProfileResponseStatsAsync, getMemberProfilesCountAsync } from './snMemberProfile.js'; 
import { closeReport } from './snRptViewrUtils.js'; 
import { appDebugMode, baseURL } from './snSite.js';

const getMemberProfileStatsRptDataAsync = async (params = {}) => {

    const [profilesCntData, statsData] = await allSettled({
        promises: [
            getMemberProfilesCountAsync(),
            getMemberProfileResponseStatsAsync()
        ]
    });
    return {
        profilesCnt: profilesCntData.status !== 'rejected' ? profilesCntData.value : 0,
        stats: statsData.status !== 'rejected' ? statsData.value : []
    }
}

const showReportAsync = async (params = {}) => {
    try {
        const rptData = await getMemberProfileStatsRptDataAsync();
        //rptData.stats = []; // Remove when we have real data to test with.  This will show the 'no data' message dialog.
        if (rptData.stats.length === 0) {
            //            $('#reportViewer1').addClass('hidden');
            //            const content = '<div>No data is available for this report.  There are two reasons that could cause this to happen</div>' +
            //                '<div>1. No Profile Information template has been setup for your church - or -</div>' +
            //                '<div>2. Church members have not entered Profile Information .</div>';
            //            $('#noDataDlg .modal-body').html(content);
            //            $('#noDataDlg').modal('show');
            const content = 'No data is available for this report.  There are two reasons that could cause this to happen\n\r' +
                '1. No Profile Information template has been setup for your church\n' +
                '2. Church members have not entered Profile Information .';
            alert(content);
            closeReport();
        } else {
            $("#reportViewer1")
                .telerik_ReportViewer({
                    serviceUrl: `${baseURL}/api/reports`,
                    templateUrl: `${baseURL}/api/ReportViewer/Template`,
                    reportSource: {
                        report: 'RptProfileStats.trdp',
                        parameters: {
                            profilesCnt: rptData.profilesCnt,
                            stats: JSON.stringify(rptData.stats)
                        }
                    },
                    viewMode: telerikReportViewer.ViewModes.INTERACTIVE,
                    scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,
                    scale: 1.0,
                    enableAccessibility: false,
                    sendEmail: { enabled: false }
                });
        }
    }
    catch (error) { console.log(error); }
}

window.snRptProfileStats = {
    showReportAsync
}